/*
  DreamWave: "View reviews" links.
  Every review link on the site points at #dw-reviews. This script sends those links
  (and any page opened with #dw-reviews in its address) straight to the Judge.me
  reviews list with the customer photos, falling back to the summary if Judge.me
  hasn't loaded.
*/
(function () {
  if (window.__dwReviewsJump) return;
  window.__dwReviewsJump = true;
  var HASH = '#dw-reviews';

  function findReviews() {
    return (
      document.getElementById('judgeme_product_reviews') ||
      document.querySelector('[id*="judge_me_reviews_review_widget"]') ||
      document.querySelector('.jdgm-review-widget') ||
      document.querySelector('.jdgm-rev-widg') ||
      document.getElementById('dw-reviews')
    );
  }

  function scrollToReviews(target, smooth) {
    target.style.scrollMarginTop = '90px';
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }

  function isReviewLink(link) {
    var href = link.getAttribute('href') || '';
    if (href.slice(-HASH.length) !== HASH) return false;
    var path = href.slice(0, -HASH.length);
    return path === '' || path === window.location.pathname || path === window.location.href.split('#')[0];
  }

  /* Capture phase, so this runs before the theme's general in-page jump for #dw- links. */
  window.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href$="' + HASH + '"]');
    if (!link || !isReviewLink(link)) return;
    var target = findReviews();
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    scrollToReviews(target, true);
  }, true);

  // Arriving from another page (e.g. the stars on a homepage product card).
  // Judge.me loads a moment after the page, so keep looking for a few seconds.
  if (window.location.hash === HASH) {
    var tries = 0;
    var timer = setInterval(function () {
      var jm = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
      tries += 1;
      if (jm || tries > 40) {
        clearInterval(timer);
        var target = jm || findReviews();
        if (target) scrollToReviews(target, false);
      }
    }, 150);
  }
})();
